// extracted by mini-css-extract-plugin
export default {"wrapper":"rY-z","ratingContainer":"sY-z","ratingValue":"tY-z","starSprite":"uY-z","ratingLabel":"vY-z","error":"wY-z","errorBox":"xY-z"};